import styled from "styled-components";

export const QuoteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Text = styled.p`
  font-size: 24px;
  line-height: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.default.default};
`;

export const Author = styled.p`
  font-size: 16px;
  font-style: italic;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.default[600]};
`;

export const Company = styled.span`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.default.default};
  display: block;
  font-style: normal;
`;
